import React, { Fragment, useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { StropheContext } from '../ChatClient'
import { ProfileApis } from '../../API/Login/ProfileApi'
import { Typography } from '@mui/material'
// import { Typography } from '@mui/material'

const BillingPageScreen = (props) => {
  const navigate = useNavigate()
  const [personalDetails, setPersonalDetails] = useState()

  const stropheContext = useContext(StropheContext)
  console.log('dashboard props', props, stropheContext)

  const { frProUser } = useSelector(
    (state) => state.Users
  )


  const userPersonalDetailsByUserId = () => {
    let mobileNumberObj = {
      fre8ProAccessToken: frProUser?.fre8ProAccessToken,
      userId: frProUser?.userId,
      page: 0,
      size: 0,
      businessId: null,
      profileId: null,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    }
    ProfileApis.getUserPersonalDetailsByUserId(mobileNumberObj)
      .then((res) => {
        // Correct way to merge the objects
        setPersonalDetails(res?.data)
      })
      .catch((err) => {
        console.debug('Mobile number not Available', err)
      })
  }


  useEffect(() => {
    userPersonalDetailsByUserId()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  console.log('-----frProUser---->', frProUser);
  console.log('-----personalDetails---->', personalDetails);
  return (
    <>
      {/* <GetUserProfile /> */}
      <main className="main users chart-page h-100 ">
        <div className="text-start cursorPointer">
          <a onClick={() => navigate(-1)} className="f-w-700 color-400 ">
            <img src="../images/back.svg" alt="" className="me-3" /> Go back
          </a>
        </div>
        <div className="container-fluid p-lg-4 h-100">
          <div className="text-start mb-4 title d-flex align-items-center justify-content-between">
            <h3 className='mb-4 memberShipDeTil'>
              Billing
            </h3>
          </div>
          <div className='reward-point-history'>
            <p className='reward-point-history-title my-4'>My invoices</p>
            <div className="responsive-tebal border rounded-3 overflow-hidden billing-table">
              <table className="table table-striped align-middle mb-0 ">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          Invoice
                        </label>

                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="arrow-down">
                            <path
                              id="Icon"
                              d="M7.9987 3.3335V12.6668M7.9987 12.6668L12.6654 8.00016M7.9987 12.6668L3.33203 8.00016"
                              stroke="#667085"
                              strokeWidth="1.33333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col">Purchase</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {Array(1)
                    ?.fill(1)
                    ?.map((_, index) => (
                      <tr key={index}>
                        <td>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckDefault"
                            >
                              #306{index}
                            </label>
                          </div>
                        </td>
                        <td>Mar 2025
                          {/* {index}, 2024 */}
                        </td>
                        <td>
                          <svg
                            width="55"
                            height="22"
                            viewBox="0 0 55 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g style={{ mixBlendMode: 'multiply' }}>
                              <rect
                                width="55"
                                height="22"
                                rx="11"
                                fill="#ECFDF3"
                              ></rect>
                              <path
                                d="M16 8L10.5 13.5L8 11"
                                stroke="#feb273"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M22.9842 15V6.27273H26.095C26.774 6.27273 27.3365 6.39631 27.7825 6.64347C28.2285 6.89062 28.5623 7.22869 28.7839 7.65767C29.0055 8.08381 29.1163 8.56392 29.1163 9.09801C29.1163 9.63494 29.0041 10.1179 28.7797 10.5469C28.5581 10.973 28.2228 11.3111 27.774 11.5611C27.3279 11.8082 26.7669 11.9318 26.0907 11.9318H23.9515V10.8153H25.9714C26.4004 10.8153 26.7484 10.7415 27.0154 10.5938C27.2825 10.4432 27.4785 10.2386 27.6035 9.98011C27.7285 9.72159 27.791 9.42756 27.791 9.09801C27.791 8.76847 27.7285 8.47585 27.6035 8.22017C27.4785 7.96449 27.2811 7.7642 27.0112 7.61932C26.7441 7.47443 26.3919 7.40199 25.9544 7.40199H24.301V15H22.9842ZM32.4039 15.1449C31.9892 15.1449 31.6142 15.0682 31.2789 14.9148C30.9437 14.7585 30.6781 14.5327 30.4821 14.2372C30.2889 13.9418 30.1923 13.5795 30.1923 13.1506C30.1923 12.7812 30.2633 12.4773 30.4054 12.2386C30.5474 12 30.7392 11.8111 30.9806 11.6719C31.2221 11.5327 31.492 11.4276 31.7903 11.3565C32.0886 11.2855 32.3926 11.2315 32.7022 11.1946C33.0943 11.1491 33.4125 11.1122 33.6568 11.0838C33.9011 11.0526 34.0787 11.0028 34.1895 10.9347C34.3002 10.8665 34.3556 10.7557 34.3556 10.6023V10.5724C34.3556 10.2003 34.2505 9.91193 34.0403 9.70739C33.8329 9.50284 33.5233 9.40057 33.1113 9.40057C32.6824 9.40057 32.3443 9.49574 32.0971 9.68608C31.8528 9.87358 31.6838 10.0824 31.59 10.3125L30.3926 10.0398C30.5346 9.64205 30.742 9.32102 31.0147 9.0767C31.2903 8.82955 31.6071 8.65057 31.965 8.53977C32.323 8.42614 32.6994 8.36932 33.0943 8.36932C33.3556 8.36932 33.6326 8.40057 33.9252 8.46307C34.2207 8.52273 34.4963 8.63352 34.752 8.79545C35.0105 8.95739 35.2221 9.18892 35.3869 9.49006C35.5517 9.78835 35.6341 10.1761 35.6341 10.6534V15H34.3897V14.1051H34.3386C34.2562 14.2699 34.1326 14.4318 33.9679 14.5909C33.8031 14.75 33.5914 14.8821 33.3329 14.9872C33.0744 15.0923 32.7647 15.1449 32.4039 15.1449ZM32.6809 14.1222C33.0332 14.1222 33.3343 14.0526 33.5843 13.9134C33.8372 13.7741 34.0289 13.5923 34.1596 13.3679C34.2931 13.1406 34.3599 12.8977 34.3599 12.6392V11.7955C34.3145 11.8409 34.2264 11.8835 34.0957 11.9233C33.9679 11.9602 33.8216 11.9929 33.6568 12.0213C33.492 12.0469 33.3315 12.071 33.1752 12.0938C33.019 12.1136 32.8883 12.1307 32.7832 12.1449C32.536 12.1761 32.3102 12.2287 32.1056 12.3026C31.9039 12.3764 31.742 12.483 31.6199 12.6222C31.5005 12.7585 31.4409 12.9403 31.4409 13.1676C31.4409 13.483 31.5574 13.7216 31.7903 13.8835C32.0233 14.0426 32.3201 14.1222 32.6809 14.1222ZM37.3311 15V8.45455H38.6053V15H37.3311ZM37.9746 7.4446C37.753 7.4446 37.5627 7.37074 37.4036 7.22301C37.2473 7.07244 37.1692 6.89347 37.1692 6.68608C37.1692 6.47585 37.2473 6.29687 37.4036 6.14915C37.5627 5.99858 37.753 5.9233 37.9746 5.9233C38.1962 5.9233 38.3851 5.99858 38.5414 6.14915C38.7005 6.29687 38.78 6.47585 38.78 6.68608C38.78 6.89347 38.7005 7.07244 38.5414 7.22301C38.3851 7.37074 38.1962 7.4446 37.9746 7.4446ZM42.7697 15.1278C42.2413 15.1278 41.7697 14.9929 41.3549 14.723C40.943 14.4503 40.6191 14.0625 40.3833 13.5597C40.1504 13.054 40.0339 12.4474 40.0339 11.7401C40.0339 11.0327 40.1518 10.4276 40.3876 9.92472C40.6262 9.42187 40.9529 9.03693 41.3677 8.76989C41.7825 8.50284 42.2527 8.36932 42.7782 8.36932C43.1845 8.36932 43.5112 8.4375 43.7583 8.57386C44.0083 8.70739 44.2015 8.86364 44.3379 9.04261C44.4771 9.22159 44.585 9.37926 44.6618 9.51562H44.7385V6.27273H46.0126V15H44.7683V13.9815H44.6618C44.585 14.1207 44.4743 14.2798 44.3294 14.4588C44.1873 14.6378 43.9913 14.794 43.7413 14.9276C43.4913 15.0611 43.1674 15.1278 42.7697 15.1278ZM43.051 14.0412C43.4174 14.0412 43.7271 13.9446 43.9799 13.7514C44.2356 13.5554 44.4288 13.2841 44.5595 12.9375C44.693 12.5909 44.7598 12.1875 44.7598 11.7273C44.7598 11.2727 44.6944 10.875 44.5637 10.5341C44.4331 10.1932 44.2413 9.92756 43.9885 9.73722C43.7356 9.54687 43.4231 9.4517 43.051 9.4517C42.6674 9.4517 42.3478 9.55114 42.0922 9.75C41.8365 9.94886 41.6433 10.2202 41.5126 10.5639C41.3848 10.9077 41.3208 11.2955 41.3208 11.7273C41.3208 12.1648 41.3862 12.5582 41.5169 12.9077C41.6475 13.2571 41.8407 13.5341 42.0964 13.7386C42.3549 13.9403 42.6731 14.0412 43.051 14.0412Z"
                                fill="#027A48"
                              ></path>
                            </g>
                          </svg>
                        </td>
                        <td>Monthly subscription</td>
                        <td>
                          <Typography
                            component={Link}
                            className={'btn border-0'}
                            to="/alliance/viewInvoice"
                            color="textSecondary"
                            variant="h6"
                            type='submit'
                            sx={{ textDecoration: 'none' }}
                          >
                            View invoice
                          </Typography>
                          {/* <button className="btn border-0">View invoice</button> */}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <ul className="pagination justify-content-center custom-pagnition">
                <li className="page-item disabled">
                  <a className="page-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M15.8332 10.0001H4.1665M4.1665 10.0001L9.99984 15.8334M4.1665 10.0001L9.99984 4.16675"
                        stroke="#667085"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    Previous
                  </a>
                </li>
                {/* <li className="page-item active"><a className="page-link" to="#">1</a></li> */}
                <li className="page-item active">
                  <Link className="page-link" to="#">
                    1
                  </Link>
                </li>

                <li className="page-item">
                  <Link className="page-link" to="#">
                    2
                  </Link>
                </li>
                <li className="page-item">
                  <Link className="page-link" to="#">
                    3
                  </Link>
                </li>
                <li className="page-item">
                  <Link className="page-link" to="#">
                    Next
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.1665 10.0001H15.8332M15.8332 10.0001L9.99984 4.16675M15.8332 10.0001L9.99984 15.8334"
                        stroke="#667085"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default BillingPageScreen
